






























































import { Component, Mixins, Vue } from 'vue-property-decorator';
import GExamCreateFormFormat from '@/views/GExamCreate/GExamCreateFormFormat.vue';
import GExamCreateSpan from '@/views/GExamCreate/BaseSetting/GExamCreateBaseSettingDateSpan.vue';
import { GEnum } from '@/constants/enum.defination';
import GExamCreateBaseSetting from '@/views/GExamCreate/BaseSetting/GExamCreateBaseSetting.vue';
import GExamCreateQuestionSetting from '@/views/GExamCreate/QuestionSetting/GExamCreateQuestionSetting.vue';
import GExamCreateExamieeSetting from '@/views/GExamCreate/ExamineeSetting/GExamCreateExamineeSetting.vue';
import GExamCreateMailSetting from '@/views/GExamCreate/MailSetting/GExamCreateMailSetting.vue';
import GExamCreateConfirmViewSetting from '@/views/GExamCreate/ConfirmView/GExamCreateConfirmView.vue';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { masterModule } from '@/store/modules/entities/master.module';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { Competency } from '@/models/competency/competency';
import { QuestionType } from '@/models/evalSetting/question-type';
import { required } from 'vuelidate/lib/validators';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { GPageBase } from '@/mixins';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { TeacherSearch } from '@/models/teacher/teacher-search';
import { EnvUtils } from '@/utils/env.utils';

Component.registerHooks(['beforeRouteLeave']);
@Component({
  name: 'GExamCreate',
  components: {
    GTitleBar,
    GCustomBreadCrumb,
    GExamCreateExamieeSetting,
    GExamCreateConfirmViewSetting,
    GExamCreateQuestionSetting,
    GExamCreateBaseSetting,
    GExamCreateSpan,
    GExamCreateFormFormat,
    GExamCreateMailSetting,
  },
  computed: {},
  methods: {},
  validations: {
    evalSettingDetail: {
      title: { required },
    },
  },
})
export default class GExamCreate extends Mixins(GPageBase) {
  title: string = '';
  competencySettingType: GEnum.CompetencySettingType = GEnum.CompetencySettingType.Full;
  evalSettingID: number = 0;
  breadCrumbItems: BreadCrumbElement[] = [];
  lazy: boolean = false;

  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === 'exam-list' && this.isAutoPageTransition) {
      // 登録後の受検一覧画面への自動遷移ではデータ喪失確認ダイアログは表示しない
      next();
    } else if (to.name === 'signin') {
      // ログアウトする場合には、データ喪失確認ダイアログは表示しない
      next();
    } else {
      this.openConfirm(
        //OK押下時は画面遷移を許容する
        () => {
          next();
        },
        () => {}
      );
    }
  }

  created() {
    examCreateModule.setMode(Number(this.$route.query['mode']));
    this.evalSettingID = Number(this.$route.query['evalSettingID']);
  }

  async mounted() {
    //初期化
    examCreateModule.clean();
    examCreateModule.cleanCompetencySelections();
    evalSettingModule.evalSettingDetail.clean();
    customCompetencyModule.clean();


    //設問設定周りのリソース取得
    await masterModule.fetchQuestionType();
    await masterModule.fetchAllQuestionType();  // 確認画面での「設問タイプ」の表示に利用されているのでここで読み込み
    await masterModule.fetchCompetency();
    await masterModule.fetchQuestionTypesWithCompetencies();
    masterModule.fetchCompetencySettingType();

    // 学校コンピテンシーの取得
    customCompetencyModule.fetchCustomCompetency();

    //傾向チェックマスタデータ取得
    masterModule.fetchTrends();

    //受検設定周りのリソース取得
    schoolClassModule.fetchGrades();
    schoolClassModule.fetchSchoolClasses();
    await schoolClassModule.fetchGradesSchoolClasses();
    examCreateModule.resetSchoolClassSelection(schoolClassModule.gradeSchoolClasses); //組ラベルセット

    //更新タイプ別に処理を変更
    switch (examCreateModule.mode) {
      case GEnum.EvalSettingMode.Create:
        this.title = this.$t('CREATE_NEW_EXAM').toString();
        this.evalSettingDetail.questionSettingType = masterModule.questionTypes[0].questionTypeID;
        examCreateModule.setCompetencySelections(masterModule.competencies); // デフォルトはフルセット
        schoolClassModule.setGradeSchoolClassesIncludeSelected();
        break;

      case GEnum.EvalSettingMode.Copy:
        this.title = this.$t('CREATE_NEW_EXAM').toString();
        await evalSettingModule.fetchEvalSettingDetail(this.evalSettingID);
        if (!evalSettingModule.evalSettingDetail.personalReportDisplayType) {
          // 既存の受検コースデータの場合、デフォルト値をセット
          evalSettingModule.evalSettingDetail.personalReportDisplayType = GEnum.PersonalReportDisplayType.SelfGrowthSupport;
        }
        // コピー or 編集の時、元の受検の「設問タイプ」が今は使われていないものだった場合に、選択可能な設問タイプの中からIDが一番小さいものを設定する
        evalSettingModule.evalSettingDetail.refreshQuestionSettingType(masterModule.questionTypes);
        evalSettingModule.evalSettingDetail.startTime = null;
        evalSettingModule.evalSettingDetail.deadline = null;
        evalSettingModule.evalSettingDetail.students = [];
        evalSettingModule.evalSettingDetail.schoolClasses = [];
        // AIGROW2-582 傾向チェックを契約していない場合、傾向チェックありの受検を作成できないようにするため
        // 受検の内容から傾向チェック関連の項目をクリアする
        if (!this.isDisplayTrend) {
          evalSettingModule.evalSettingDetail.cleanTrend();
        }
        // コピー時、メール設定は引き継がない
        evalSettingModule.evalSettingDetail.cleanMailSetting();
        examCreateModule.setCompetencySelections(this.evalSettingDetail.competencyIDs.map((competencyID: number) => masterModule.toCompetency(competencyID)));
        schoolClassModule.setGradeSchoolClassesIncludeSelected();
        break;

      case GEnum.EvalSettingMode.Edit:
        await evalSettingModule.fetchEvalSettingDetail(this.evalSettingID);
        if (!evalSettingModule.evalSettingDetail.personalReportDisplayType) {
          // 既存の受検コースデータの場合、デフォルト値をセット
          evalSettingModule.evalSettingDetail.personalReportDisplayType = GEnum.PersonalReportDisplayType.SelfGrowthSupport;
        }
        // コピー or 編集の時、元の受検の「設問タイプ」が今は使われていないものだった場合に、選択可能な設問タイプの中からIDが一番小さいものを設定する
        evalSettingModule.evalSettingDetail.refreshQuestionSettingType(masterModule.questionTypes);
        this.title = this.$t('EDIT_EXAM', {value: this.evalSettingDetail.title}).toString();
        examCreateModule.setCompetencySelections(this.evalSettingDetail.competencyIDs.map((competencyID: number) => masterModule.toCompetency(competencyID)));
        if (this.evalSettingDetail.schoolClasses.length > 0) {
          examCreateModule.setSchoolClassSelection(this.evalSettingDetail.schoolClasses); //チェックボックスグループに値をセット
          schoolClassModule.setGradeSchoolClassesIncludeSelected(this.evalSettingDetail.schoolClasses); //学年クラスデータにチェックボックスグループの値を反映
          examCreateModule.setExamnieeSelectionType(GEnum.ExamineeSelectionType.Class);
        } else {
          examCreateModule.setAlreadyAssignedStudentIDs(this.evalSettingDetail.students);
          examCreateModule.setExamnieeSelectionType(GEnum.ExamineeSelectionType.Student);
        }
        // メールの更新へのパラメータが付いていたら
        const step = Number(this.$route.query['step']);
        if (step === GEnum.ExamCreateStep.MailSettingStep) {
          examCreateModule.setCurrentStep(step);
        }
        break;
      default:
    }

    //設問タイプに有効なコンピテンシーをセット
    const competenciesIncludeIsValid: Competency[] = masterModule.competenciesByQuestionTypeID(this.evalSettingDetail.questionSettingType);
    masterModule.setCompetenciesIncludeIsValid(competenciesIncludeIsValid);

    // メール設定用に先生一覧を取得
    teacherModule.fetchTeacherList({} as TeacherSearch);

    this.breadCrumbItems = [{ title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' }, { title: this.$t('MENU_EVAL_COURSE').toString() }, { title: this.title }];

    this.lazy = true;
  }

  get mode(): number {
    return examCreateModule.mode;
  }

  get questionTypes(): QuestionType[] {
    return masterModule.questionTypes;
  }

  get competencyIDs(): number[] {
    return masterModule.competencyIDs;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get currentStep(): number {
    return examCreateModule.currentStep;
  }

  get evalSettingModeCreate(): boolean {
    return examCreateModule.mode === GEnum.EvalSettingMode.Create;
  }

  get evalSettingModeEdit(): boolean {
    return examCreateModule.mode === GEnum.EvalSettingMode.Edit;
  }

  get evalSettingModeCopy(): boolean {
    return examCreateModule.mode === GEnum.EvalSettingMode.Copy;
  }

  get visitConfirmView(): boolean {
    return examCreateModule.visitConfirmView;
  }

  get currentBaseSetting(): boolean {
    return this.currentStep === GEnum.ExamCreateStep.BaseSettingStep;
  }

  get currentQuestionSetting(): boolean {
    return this.currentStep === GEnum.ExamCreateStep.QuestionSettingStep;
  }

  get currentExamineeSetting(): boolean {
    return this.currentStep === GEnum.ExamCreateStep.ExamineeSettingStep;
  }

  get currentMailSetting(): boolean {
    // メール機能を使う場合（feature flag true なら）
    if (this.isFeatureFlagTeacherMail) {
      return this.currentStep === GEnum.ExamCreateStep.MailSettingStep;
    }
    // メール機能を使わない場合 常に false
    return false;
  }

  get currentConfirmView(): boolean {
    // メール機能を使う場合（feature flag true なら）
    if (this.isFeatureFlagTeacherMail) {
      return this.currentStep === GEnum.ExamCreateStep.ConfirmViewStep;
    }
    return this.currentStep === GEnum.ExamCreateStepWithoutGiftCourseMail.ConfirmViewStep;
  }

  get isAutoPageTransition(): boolean {
    return examCreateModule.isAutoPageTransition;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  // feature flag AIGROW2-518 teacher mail
  get isFeatureFlagTeacherMail(): boolean {
    return EnvUtils.getBoolean("VUE_APP_FEATURE_FLAG_GIFT_COURSE_MAIL")
  }

  isValid(): boolean {
    const { baseSetting, questionSetting, examineeSetting, mailSetting }: any = this.$refs;
    if (this.currentBaseSetting && !baseSetting.isValid) {
      return false;
    } else if (this.currentQuestionSetting && !questionSetting.isValid) {
      return false;
    } else if (this.currentExamineeSetting && !examineeSetting.isValid && !this.evalSettingModeEdit) {
      return false;
    } else if (this.currentMailSetting && !mailSetting.isValid) {
      return false;
    }
    return true;
  }

  openConfirm(ok: () => void, cancel: () => void) {
    let config = {
      title: this.$t('CONFIRM_RESET_SETTING').toString(),
      width: 500,
      onOk: () => {
        ok();
      },
      onCancel: () => {
        cancel();
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  handleReturn() {
    examCreateModule.setCurrentStep(this.currentStep - 1);
  }
  handleNext() {
    if (!this.isValid()) {
      return;
    }
    examCreateModule.setCurrentStep(this.currentStep + 1);
  }
  handleConfirmReturn() {
    if (!this.isValid()) {
      return;
    }
    if (this.isFeatureFlagTeacherMail) {
      examCreateModule.setCurrentStep(GEnum.ExamCreateStep.ConfirmViewStep);
    } else {
      examCreateModule.setCurrentStep(GEnum.ExamCreateStepWithoutGiftCourseMail.ConfirmViewStep);
    }
  }
}
